/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-07-05 19:53:35
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-07-21 19:58:29
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/components/NpsTopic/NpsEdit.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  defineComponent,
  getCurrentInstance,
  reactive,
  watch
} from '@vue/composition-api'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import './index.scss'
import _ from 'lodash'
import { SCORE_TYPE } from '../../config'
import i18n from '@/locales'
import OptionSettings from '../../../SurveyDetail/compontents/optionSettings'
import BarScore from '@/pages/Survey/components/BarScore'
import StarScore from '@/pages/Survey/components/StarScore'
import FaceScore from '@/pages/Survey/components/FaceScore'
import CommonTetxEdit from '@/components/CommonTetxEdit'

const NpsEdit = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      editItem: _.cloneDeep(props.item) //编辑数据源
    })
    const instance = getCurrentInstance()
    //i18n 国际化
    const tran = function (initParam) {
      return instance?.proxy.$t(initParam) as string
    }
    // instance?.proxy.$set(state.editItem.topicSetting,'customizeOptionValue','')
    watch(
      () => state.editItem,
      (val) => {
        emit('changeTopicContent', val)
      },
      {
        deep: true
      }
    )

    return () => {
      //给默认值
      return (
        <div class="topic-edit-content">
          <div class="topic-edit-content-item  topic-edit-content-title">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.npsquestionName')}:
            </div> */}
            {/* <RichUtil
              onchangeValue={(value) => (state.editItem.topicName = value)}
              placeholder={tran('survy.plctopicname')}
              value={state.editItem.topicName}></RichUtil> */}
            {!state.editItem.isAddStatus && (
              <div class="topic-edit-content-title-order">
                {!state.editItem.topicSetting.isAllowNull && <i>*</i>}
                {state.editItem.order}.
              </div>
            )}
            <div style={{ width: '100%' }}>
              <CommonTetxEdit
                needDynamicEvent
                initialData={state.editItem.topicName}
                placeholder={tran('survy.npsquestionName')}
                handleUpdate={(value) => {
                  state.editItem.topicName = value
                }}
              />
            </div>
          </div>
          <div class="topic-edit-content-item">
            {/* <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              size="small"
              resize="none"
              placeholder="请输入题目备注"
              value={state.editItem.topicSetting.topicRemark}
              onInput={(value) =>
                (state.editItem.topicSetting.topicRemark = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent
              initialData={state.editItem.topicSetting.topicRemark}
              placeholder={tran('survy.plcremark')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.topicRemark = value
              }}
            />
          </div>
          <div class="topic-edit-content-item">
            {!state.editItem.topicSetting.scoreStyle && (
              <BarScore
                minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                maxScore={10}
                isNps={true}
                onupdateValue={(value) => {}}
                value={state.editItem.value}
                topicSetting={state.editItem.topicSetting}></BarScore>
            )}
            {state.editItem.topicSetting.scoreStyle == 1 && (
              <StarScore
                minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                maxScore={10}
                isNps={true}
                onupdateValue={(value) => {}}
                value={state.editItem.value}
                topicSetting={state.editItem.topicSetting}></StarScore>
            )}
            {state.editItem.topicSetting.scoreStyle == 2 && (
              <FaceScore
                minScoreDesc={state.editItem.topicSetting.minScoreDesc}
                maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
                maxScore={10}
                isNps={true}
                onupdateValue={(value) => {}}
                value={state.editItem.value}
                topicSetting={state.editItem.topicSetting}></FaceScore>
            )}
          </div>

          {/* <div class="topic-edit-content-item nps-edit-input">
            <el-row>
              <el-col span={8}>
                <el-checkbox
                  key="noneedans"
                  value={state.editItem.topicSetting.isAllowNull}
                  onInput={(value) =>
                    (state.editItem.topicSetting.isAllowNull = value)
                  }>
                  {tran('survy.noneedans')}
                </el-checkbox>
              </el-col>
              <el-col span={8}> */}
          {/* 自定义选项配置 key未知，等后端，暂用 customeOption */}
          {/* <el-checkbox
                  label="1"
                  key="customizeOption"
                  value={
                    state.editItem.topicSetting.customizeOption ? true : false
                  }
                  onInput={(value) => {
                    if (value) {
                      value = 1
                      if (!state.editItem.topicSetting.customizeOptionValue) {
                        state.editItem.topicSetting.customizeOptionValue = `${tran(
                          'survy.uncertain'
                        )}`
                      }
                    } else {
                      value = 0
                    }
                    state.editItem.topicSetting.customizeOption = value
                  }}>
                  {tran('survy.customeOption')}
                </el-checkbox>
                <el-input
                  size="small"
                  value={state.editItem.topicSetting.customizeOptionValue}
                  onInput={(value) => {
                    value = value.replace(/[0-9]/g, '')
                    state.editItem.topicSetting.customizeOptionValue = value
                  }}
                  onfocus={() => {
                    if (!state.editItem.topicSetting.customizeOption) {
                      state.editItem.topicSetting.customizeOption = 1
                    }
                  }}
                  placeholder={tran('survy.plccontent')}
                  style={{ marginLeft: '12px' }}
                  maxlength={i18n.locale === 'en' ? '9' : '4'} 
          ></el-input>
            </el-col>
            </el-row>
          </div> */}
          {/* <div class="topic-edit-content-item nps-edit-input">
            <el-row>
              <el-col span={8}>
                <span class="topic-edit-content-item-label">
                  {tran('survy.lowdes')}{' '}
                </span>
                <el-input
                  size="small"
                  value={state.editItem.topicSetting.minScoreDesc}
                  onInput={(value) =>
                    (state.editItem.topicSetting.minScoreDesc = value)
                  }
                  placeholder={tran('survy.plccontent')}></el-input>
              </el-col>

              <el-col span={8}>
                <span class="topic-edit-content-item-label">
                  {tran('survy.highdes')}{' '}
                </span>
                <el-input
                  size="small"
                  value={state.editItem.topicSetting.maxScoreDesc}
                  onInput={(value) =>
                    (state.editItem.topicSetting.maxScoreDesc = value)
                  }
                  placeholder={tran('survy.plccontent')}></el-input>
              </el-col>
              <el-col span={8}>
                <span class="topic-edit-content-item-label">
                  {tran('survy.style')}{' '}
                </span>
                <el-select
                  size="small"
                  onInput={(value) =>
                    (state.editItem.topicSetting.scoreStyle = value)
                  }
                  value={state.editItem.topicSetting.scoreStyle}
                  placeholder={tran('survy.plcselect')}>
                  {SCORE_TYPE.map((sitem) => {
                    return (
                      <el-option
                        key={sitem.value}
                        label={sitem.label}
                        value={sitem.value}></el-option>
                    )
                  })}
                </el-select>
              </el-col>
            </el-row>
          </div> */}
          {/* 结束语 */}
          <div class="topic-edit-content-item">
            {/* <div class="topic-edit-content-item-title">
              {tran('survy.npselend')}:
            </div>
            <RichUtil
              needDynamicEvent={false}
              onchangeValue={(value) =>
                (state.editItem.topicSetting.endword = value)
              }
              placeholder={tran('survy.earlyend')}
              value={state.editItem.topicSetting.endword}></RichUtil> */}
            {/* <el-input
              type="textarea"
              class="rich-input"
              autosize={true}
              resize="none"
              size="small"
              placeholder="NPS题提前结束语"
              value={state.editItem.topicSetting.endword}
              onInput={(value) =>
                (state.editItem.topicSetting.endword = value)
              }></el-input> */}
            <CommonTetxEdit
              needDynamicEvent={true}
              initialData={state.editItem.topicSetting.endword}
              placeholder={tran('survy.npselend')}
              handleUpdate={(value) => {
                state.editItem.topicSetting.endword = value
              }}
            />
          </div>
          <Portal to="survey-option-settings">
            <OptionSettings
              type={props.item.topicType}
              isAllowNull={state.editItem.topicSetting.isAllowNull}
              minScoreDesc={state.editItem.topicSetting.minScoreDesc}
              maxScoreDesc={state.editItem.topicSetting.maxScoreDesc}
              scoreStyle={state.editItem.topicSetting.scoreStyle}
              customizeOption={
                state.editItem.topicSetting.customizeOption ? true : false
              }
              customizeOptionValue={
                state.editItem.topicSetting.customizeOptionValue
              }
              onChangeIsAllowNull={(value) => {
                state.editItem.topicSetting.isAllowNull = value
              }}
              onChangeMinScoreDesc={(value) => {
                state.editItem.topicSetting.minScoreDesc = value
              }}
              onChangeMaxScoreDesc={(value) => {
                state.editItem.topicSetting.maxScoreDesc = value
              }}
              onChangeScoreStyle={(value) => {
                state.editItem.topicSetting.scoreStyle = value
              }}
              onChangeCustomizeOption={(value) => {
                state.editItem.topicSetting.customizeOption = value
              }}
              onChangeCustomizeOptionValue={(value) => {
                state.editItem.topicSetting.customizeOptionValue = value
              }}
            />
          </Portal>
        </div>
      )
    }
  }
})
export default NpsEdit
